import React, { useEffect, useState } from 'react';
import useIntersectionObserver from '@components/service-and-repair/hooks/use-intersection-observer/use-intersection-observer';

export type ObserverWrapperProps = {
  children: React.ReactNode;
  onViewed: () => void;
};

export const ObserverWrapper = ({ children, onViewed }) => {
  const [hasObserved, setHasObserved] = useState(false);
  const { isIntersecting, targetRef } = useIntersectionObserver({ threshold: 0.5 });

  useEffect(() => {
    if (isIntersecting && !hasObserved) {
      onViewed();
      setHasObserved(true);
    }
  }, [isIntersecting]);

  return <div ref={targetRef}>{children}</div>;
};
